export const MODAL_NAME = 'LoanMonitoringModal'
